import React from "react"
import { AppRoutes } from "../../../consts/appRoutes.consts"
import TabView from "../../../components/atoms/tabView/TabView.atom"
import TabPanel from "../../../components/atoms/tabView/TabPanel.atom"
import ClientReportControls from "./ClientReportControls.controller"
import ClientDevelopment from "./Development/ClientDevelopment.controller"
import ClientConsumption from "./Consumption/ClientConsumption.controller"
import ClientReportDownload from "./Download/ClientReportDownload.controller"
import ClientBurnchart from "./Burnchart/ClientBurnchart.controller"
import ClientTasks from "./Tasks/ClientTasks.controller"

import { validateIsPeriodTypeSprint } from "../../../utils/clientReport.utils"
import Tooltip from "../../../components/atoms/Tooltip.atom"
import { clsx, generateRandomId } from "../../../utils/strings.utils"
import useTabPathNavigate from "../../../hooks/useTabPathNavigate.hook"
import { CLIENT_REPORT_TABS } from "../../../consts/modules/clientReport.consts"
import ClientHistory from "./History/ClientHistory.controller"

const ClientReportContent = ({
  selectedPeriod,
  setSelectedPeriod,
  refresh,
  setRefresh,
  triggerRefresh,
  dateRange,
  setDateRange,
  visibleMap,
  setVisibleMap,
  clientHasValidSprint,
  setClientHasValidSprint,
  clientSprints = [],
  setClientSprints = () => {},
  sprintBlocks = [],
  sprintCycles = [],
  period,
  setPeriod,
  extraData,
}) => {
  const { activeIndex, handleTabChange } = useTabPathNavigate({
    availableTabs: CLIENT_REPORT_TABS,
    baseRoute: AppRoutes.reporteCliente.base,
  })

  const tabTooltipClassName = `client-report-tab-${generateRandomId()}`
  const isPeriodTypeSprint = validateIsPeriodTypeSprint(period)

  return (
    <div id="reporte-cliente">
      <div className="mobile-tab-view-nav-button">
        {activeIndex !== 0 && (
          <button
            className="p-tabview-nav-prev p-tabview-nav-btn p-link"
            type="button"
            onClick={() => handleTabChange({ index: activeIndex - 1 })}
          >
            <span className="pi pi-chevron-left" aria-hidden="true"></span>
          </button>
        )}
        {activeIndex === 0 && <span>Desarrollo</span>}
        {activeIndex === 1 && <span>Consumo</span>}
        {activeIndex === 2 && <span>Burnchart</span>}
        {activeIndex === 3 && <span>Participantes</span>}
        {activeIndex === 4 && <span>Histórico de sprints</span>}
        {activeIndex === 5 && <span>Tareas</span>}
        {activeIndex === 6 && <span>Descarga</span>}
        <span className="tabview-underline" />
        {activeIndex !== 6 && (
          <button
            className="p-tabview-nav-next p-tabview-nav-btn p-link"
            type="button"
            onClick={() => handleTabChange({ index: activeIndex + 1 })}
          >
            <span className="pi pi-chevron-right" aria-hidden="true"></span>
          </button>
        )}
      </div>
      <ClientReportControls
        refresh={refresh}
        period={period}
        setPeriod={setPeriod}
        dateRange={dateRange}
        setDateRange={setDateRange}
        setRefresh={setRefresh}
        loading={false}
        currentTab={CLIENT_REPORT_TABS[activeIndex]}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        clientSprints={clientSprints}
        setClientSprints={setClientSprints}
        setClientHasValidSprint={setClientHasValidSprint}
        sprintBlocks={sprintBlocks}
        sprintCycles={sprintCycles}
      />
      <TabView
        className="reporte-cliente-tabs"
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
      >
        <TabPanel
          className={clsx("desarrollo", tabTooltipClassName)}
          header="Desarrollo"
          disabled={!isPeriodTypeSprint}
        >
          <ClientDevelopment
            dateRange={dateRange}
            period={period}
            sprintData={selectedPeriod}
            refresh={refresh}
            triggerRefresh={triggerRefresh}
          />
        </TabPanel>
        <TabPanel className="consumo" header="Consumo">
          <ClientConsumption
            dateRange={dateRange}
            period={period}
            selectedPeriod={selectedPeriod}
            refresh={refresh}
            triggerRefresh={triggerRefresh}
          />
        </TabPanel>
        <TabPanel className="burnchart single-card-tab" header="Burnchart">
          <ClientBurnchart
            period={period}
            selectedPeriod={selectedPeriod}
            refresh={refresh}
            extraData={extraData}
          />
        </TabPanel>
        <TabPanel
          className={clsx("historico-sprints", tabTooltipClassName)}
          header="Histórico"
          disabled={!isPeriodTypeSprint}
        >
          <ClientHistory
            selectedPeriod={selectedPeriod}
            period={period}
            dateRange={dateRange}
            clientSprints={clientSprints}
          />
        </TabPanel>
        <TabPanel className="tareas" header="Tareas">
          <ClientTasks
            periodType={period}
            selectedPeriod={dateRange}
            clientSprints={clientSprints}
            selectedPeriodObject={selectedPeriod}
            clientHasValidSprint={clientHasValidSprint}
          />
        </TabPanel>
        <TabPanel
          className={clsx("descarga", tabTooltipClassName)}
          header="Reporte Interno"
          disabled={!isPeriodTypeSprint}
        >
          <ClientReportDownload
            dateRange={dateRange}
            period={period}
            sprintData={selectedPeriod}
            refresh={refresh}
            triggerRefresh={triggerRefresh}
            visibleMap={visibleMap}
            setVisibleMap={setVisibleMap}
            extraData={extraData}
          />
        </TabPanel>
      </TabView>
      <DisabledTabTooltip
        target={tabTooltipClassName}
        visible={!isPeriodTypeSprint}
      />
    </div>
  )
}

const DisabledTabTooltip = ({
  target,
  position = "top",
  content = "Esta vista solo está disponible al seleccionar el periodo de Sprint",
  visible = false,
}) => {
  if (!visible) return null
  return (
    <Tooltip target={`.${target} .p-tabview-title`} position={position}>
      {content}
    </Tooltip>
  )
}

export default ClientReportContent
